(function() {
  let instances = {};
  let resizeTimer; 

  function init(id) {
    const imageEl = document.getElementById('bd-testimonial-with-images-swiper-' + id);
    const textEl = document.getElementById('testimonial-texts-slider-' + id);

    if (!imageEl || !textEl) return;

    const scrollbar = document.querySelector('.testimonial-scroll-bar');
    
    if (!scrollbar) return;

    const slides = imageEl.querySelectorAll('.swiper-slide');
    const slideCount = slides.length;
    const isMobile = window.innerWidth <= 768;
    const isTablet = window.innerWidth > 768 && window.innerWidth <= 1024;
    const isDesktop = window.innerWidth > 1024;

    // Destroy previous if exists
    if (instances[id]) {
      instances[id].image?.destroy(true, true);
      instances[id].text?.destroy(true, true);
    }

    let imageSwiper = null;
    let textSwiper = null;

    // CASES TO SKIP IMAGE SWIPER
    const skipImageSwiper =
      (isDesktop && slideCount <= 4) ||
      (isTablet && slideCount <= 4) ||
      (isMobile && slideCount <= 1);

    // CASE: Mobile with only one slide → skip both
    if (isMobile && slideCount <= 1) {
      return;
    }

    // TEXT SWIPER INIT — always if more than 1 slide
    if (slideCount > 1) {

      // if (isMobile) {
      //   textSwiper = new Swiper(textEl, {
      //     loop: true,
      //     spaceBetween: 0,
      //     slidesPerView: 1,
      //     grabCursor: true,
      //     scrollbar: {
      //       el: textEl.querySelector('.testimonial-scroll-bar'),
      //     },
      //     on: {
      //       slideChange: function () {
      //         // Highlight corresponding image when text changes
      //         if (skipImageSwiper) {
      //           const activeIndex = textSwiper.realIndex;
      //           highlightImage(activeIndex, slides);
      //         }
      //       },
      //     },
      //   });
      // } else {
        textSwiper = new Swiper(textEl, {
          loop: false,
          spaceBetween: 0,
          slidesPerView: 1,
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
          },
          centeredSlides: false,
          scrollbar: {
            el: textEl.querySelector('.testimonial-scroll-bar'),
          },
          on: {
            slideChange: function () {
              // Highlight corresponding image when text changes
              if (skipImageSwiper) {
                const activeIndex = textSwiper.realIndex;
                highlightImage(activeIndex, slides);
              }
            },
          },
        });
      // }
    }

    // IMAGE SWIPER INIT — only if not skipped
    if (!skipImageSwiper) {


      imageSwiper = new Swiper(imageEl, {
        loop: false,
        centeredSlides: true,
        lazy: true,
        watchSlidesProgress: true,
        autoHeight: false,
        watchSlidesVisibility: true,
        watchOverflow: true,
        grabCursor: true,
        spaceBetween: 0,
        mousewheel: {
          enabled: true,
          releaseOnEdges: true,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
        },
        scrollbar: {
          el: imageEl.querySelector('.testimonial-scroll-bar'),
        },
        breakpoints: {
          // Mobile (below 768px)
          0: {
            slidesPerView: 1.18,
            centeredSlides: false,
          },

          // Tablet (769px - 1023px)
          769: {
            slidesPerView: slideCount > 3 ? 3 : slideCount,
            centeredSlides: true,
          },

          // Desktop (1024px and up)
          1024: {
            slidesPerView: slideCount > 5 ? 5 : Math.max(slideCount - 2, 2),
            centeredSlides: true,
          },
        },
      });


      // Sync both when both exist
      if (textSwiper) {
        imageSwiper.controller.control = textSwiper;
        textSwiper.controller.control = imageSwiper;
      }
    } else {
      // When imageSwiper skipped → just highlight first image
      highlightImage(0, slides);
    }

    // Save instances for cleanup
    instances[id] = { image: imageSwiper, text: textSwiper };

    // setTimeout(() => imageEl.classList.add('is-active'), 600);


  }

  // Helper function to highlight current image
  function highlightImage(activeIndex, slides) {
    slides.forEach((slide, i) => {
      if (i === activeIndex) {
        slide.classList.add('highlight-border');
      } else {
        slide.classList.remove('highlight-border');
      }
    });
  }

  function destroy(id) {
    if (instances[id]) {
      // Safely destroy both swiper instances if they exist
      if (instances[id].image && instances[id].image.destroy) {
        instances[id].image.destroy(true, true);
      }
      if (instances[id].text && instances[id].text.destroy) {
        instances[id].text.destroy(true, true);
      }

      // Clean up
      delete instances[id];
    }
  }

  function initAll() {
    document.querySelectorAll('.bd-testimonial-with-images[data-section-id]').forEach(function(section) {
      const id = section.getAttribute('data-section-id');
        init(id);
    });
  }

  // ADD THIS ENTIRE FUNCTION
  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      Object.keys(instances).forEach(function(id) {
        destroy(id);
      });
      initAll();
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // window.addEventListener('resize', handleResize); 
  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail && e.detail.sectionId) {
      requestAnimationFrame(() => {
        init(e.detail.sectionId);
      });
      // setTimeout(function() {
      //   init(e.detail.sectionId);
      // }, 100);
    }
  });

  document.addEventListener('shopify:section:unload', function(e) {
    if (e.detail && e.detail.sectionId) {
      destroy(e.detail.sectionId);
    }
  });
  
  document.addEventListener('shopify:block:select', function(e) {
    const swiper = instances[e.detail && e.detail.sectionId];
    if (swiper) {
      const idx = [...swiper.slides].findIndex(function(s) {
        return s.querySelector('[data-block-id="' + e.detail.blockId + '"]');
      });
      if (idx !== -1) swiper.slideTo(idx);
    }
  });
})();